import { generateQueryParams } from '@xmatters/redux/services/util';
import { call } from 'actions/xmAPI';

const getAllPaginated =
  (uri, params = {}) =>
  dispatch => {
    const { queryParams, type } = params;
    dispatch({ type: `${type}_START` });

    // To be populated:
    let allData = [];

    const fetch = currentUri =>
      call(currentUri)
        .then(({ data, links }) => {
          allData = allData.concat(data);

          if (links.next) {
            // Continue to the next link:
            return fetch(links.next);
          }
          dispatch({ type: `${type}_SUCCESS`, payload: allData });
          return allData;
        })
        .catch(error => {
          dispatch({ type: `${type}_FAIL`, error });
        });

    const query = generateQueryParams(queryParams);
    const queryUrlPart = query ? `?${query}` : '';
    return fetch(`${uri}${queryUrlPart}`);
  };

export default getAllPaginated;
